import Ajax from "./injectAjax";

const isIos = () => {
  let ua = navigator.userAgent.toLowerCase();
  if (ua.match(/(iPhone|iPad|iPod|iOS|Mac)/i)) {
    return 1;
  } else if (ua.match(/Android/i)) {
    return 2;
  }
};
// 获取ztVersion下的cookie
const getCookies = () => {
  let strcookie = document.cookie;
  let r = new RegExp("zwzt_version=([^;]*)");
  let maps: any = {};
  let matchs = strcookie.match(r);

  if (!matchs) return maps;

  let cookies = matchs[0].split(",");
  cookies &&
    cookies.forEach(item => {
      let [key, val] = item.split("=");
      maps[key] = val;
    });
  return maps;
};

const WeiXin = {
  // 初始化
  _init(title: string, desc: string, WX_URL: string, imgUrl: string) {
    let self = this;
    Ajax.ajax({
      url: "/sdk/api/wxShare",
      method: "get",
      params: {
        url: WX_URL
      }
    }).then(res => {
      let url = decodeURIComponent(WX_URL);
      if (res.status === 200) {
        let data: any = res.data;
        self._config(data, title, desc, url, imgUrl);
      }
    });
  },
  // 验证微信config
  _config(data: any, title: string, desc: string, url: string, imgUrl: string) {
    let Window: any = window;
    Window.wx.config({
      debug: false, // 开启调试模式,调用的所有api的返回值会在客户端al
      appId: data.appId, // 必填，公众号的唯一标识
      timestamp: data.timestamp, // 必填，生成签名的时间戳
      nonceStr: data.nonceStr, // 必填，生成签名的随机串
      signature: data.signature, // 必填，签名，见附录1
      jsApiList: [
        "onMenuShareTimeline",
        "onMenuShareAppMessage",
        "onMenuShareQQ",
        "onMenuShareWeibo",
        "onMenuShareQZone",
        "hideMenuItems",
        "showMenuItems"
      ]
    });
    Window.wx.ready(function() {
      // 获取“分享到朋友圈”按钮点击状态及自定义分享内容接口
      Window.wx.onMenuShareTimeline({
        title, // 分享标题
        link: url,
        imgUrl // 分享图标
      });
      // 获取“分享给朋友”按钮点击状态及自定义分享内容接口
      Window.wx.onMenuShareAppMessage({
        title, // 分享标题
        link: url,
        imgUrl, // 分享图标
        desc
      });
      // qq
      Window.wx.onMenuShareQQ({
        title, // 分享标题
        link: url,
        imgUrl, // 分享图标
        desc
      });
      // qq空间
      Window.wx.onMenuShareQZone({
        title, // 分享标题
        link: url,
        imgUrl // 分享图标
      });
      // 微博
      Window.wx.onMenuShareWeibo({
        title, // 分享标题
        link: url,
        imgUrl, // 分享图标
        desc
      });
    });
  }
};

const isEquipment = () => {
  let UA = navigator.userAgent;
  let isAndroid = /android|adr|linux/gi.test(UA);
  let isIOS = /iphone|ipod|ipad/gi.test(UA) && !isAndroid;
  let isBlackBerry = /BlackBerry/i.test(UA);
  let isWindowPhone = /IEMobile/i.test(UA);
  let isMobile = isAndroid || isIOS || isBlackBerry || isWindowPhone;
  return {
    isAndroid,
    isIOS,
    isMobile,
    isWeixin: /MicroMessenger/gi.test(UA),
    isQQ: /QQ/gi.test(UA),
    isPC: !isMobile,
    isWeibo: /WeiBo/gi.test(UA)
  };
};
const openApp = (localUrl: string) => {
  var downUrl = '';
  let _document: any = document;
  if (isIos() === 1) {
    if (isEquipment().isWeibo || isEquipment().isWeixin || isEquipment().isQQ) {
      _document.querySelector('.middle_page').classList.remove('hide').add('show');
      _document.querySelector('.open_ua_img').classList.remove('hide').add('show');
    } else {
      downUrl = 'http://lwurl.to/9x7kc';
      //判断是否是ios,具体的判断函数自行百度
      window.location.href = localUrl;
      setTimeout(function () {
        window.location.href = downUrl;
      }, 2000);
    }
  } else if (isIos() === 2) {
    if (isEquipment().isWeixin) {
      downUrl = 'https://a.app.qq.com/o/simple.jsp?pkgname=zwzt.fangqiu.edu.com.zwzt&ckey=CK1441280218858';
    } else if (isEquipment().isQQ) {
      downUrl = 'https://a.app.qq.com/o/simple.jsp?pkgname=zwzt.fangqiu.edu.com.zwzt&ckey=CK1441283115905';
    } else {
      downUrl = 'https://a.app.qq.com/o/simple.jsp?pkgname=zwzt.fangqiu.edu.com.zwzt&ckey=CK1441367392706';
    }
    if (isEquipment().isWeibo || isEquipment().isWeixin) {
      _document.querySelector('.middle_page').classList.remove('hide').add('show');
    } else if (isEquipment().isQQ) {
      window.location.href = localUrl;
      // setTimeout(function () {
      //   window.location.href = downUrl;
      // }, 2000);
    } else {
      // // uc无法自动唤起
      window.location.href = localUrl;
      // setTimeout(function () {
      //   window.location.href = downUrl;
      // }, 2000);
    }
    // _document.querySelector('.naviBox').classList.remove('hide');
  } else {
    window.location.href = 'http://www.zuowenzhitiao.com/'
  }
};

const downloadApp = () => {
  // 先判断微信在判断qq
  if (isIos() === 1) {
    window.location.href = 'http://lwurl.to/9x7kc';
  } else if (isIos() === 2) {
    if (isEquipment().isWeixin) {
      window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=zwzt.fangqiu.edu.com.zwzt&ckey=CK1441280218858';
    } else if (isEquipment().isQQ) {
      window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=zwzt.fangqiu.edu.com.zwzt&ckey=CK1441283115905';
    } else {
      window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=zwzt.fangqiu.edu.com.zwzt&ckey=CK1441367392706';
    }
  } else {
    window.location.href = 'https://www.zuowenzhitiao.com/';
  }
};

const navigatorToApp = (url: string) => {
  let schemeUrl: string = 'zuowenzhitiao://com.qihe';
  let webviewUrl = `${schemeUrl}?routerUrl=${encodeURIComponent(`zuowenzhitiao://main/webView?url=${encodeURIComponent(url)}`)}`;
  console.log(webviewUrl);
  openApp(webviewUrl);
};

//外链跳回app
const openappfunc = (url:string) => {
  let schemeUrl = 'zuowenzhitiao://com.qihe';
  let webviewUrl = `${schemeUrl}?routerUrl=${encodeURIComponent(`zuowenzhitiao://main/webView?url=${encodeURIComponent(url)}`)}`
  openApp(webviewUrl);
}

const toDecimal2 = (x: any) => {
  let f = parseFloat(x);
  if (isNaN(f)) {
    return false;
  }
  let h = Math.round(x * 100) / 100;
  let s = h.toString();
  let rs = s.indexOf('.');
  if (rs < 0) {
    rs = s.length;
    s += '.';
  }
  while (s.length <= rs + 2) {
    s += '0';
  }
  return s;
};
const regFenToYuan = (fen:any, decimal: 1 | 2 = 2, deleteZero=false) => {
  let num = fen;
  num = fen * 0.01;
  num += '';
  let reg = num.indexOf('.') > -1 ? /(\d{1,3})(?=(?:\d{3})+\.)/g : /(\d{1,3})(?=(?:\d{3})+$)/g;
  num = num.replace(reg, '$1');
  num = toDecimal2(num)

  if(typeof num === 'string') {
    let n = num.split('.')[1].slice(0, decimal)
    if(deleteZero && Number(n) === 0) {
      num = num.split('.')[0]
    }else if(decimal === 1) {
      num = num.slice(0, num.length - 1)
    }
  }

  return num
};
const formatDate = (timeStamp:any, type = 1) => {
  //type  1 年月日   2 用点分隔
  let date = new Date(timeStamp);
  let y = date.getFullYear();
  let m:any= date.getMonth() + 1;
  m = m < 10 ? ('0' + m) : m;
  let d:any = date.getDate();
  d = d < 10 ? ('0' + d) : d;
  if (type === 1) {
    return y + '年' + m + '月' + d + '日';
  } else if (type === 2) {
    return y + '.' + m + '.' + d;
  }
}
const regYuanToFen = (yuan: any, digit = 100) => {
  let m = 0;
  let s1 = yuan.toString();
  let s2 = digit.toString();
  try { 
    m += s1.split(".")[1].length;
  } catch (e) {

  }
  try { m += s2.split(".")[1].length; } catch (e) { }
  return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m);
};

const srollFunction:any = {
  scrollTop: null,
  doc: null,
  reg: null,
  bodyClassName: '',
  afterOpen: (bodyEle:any, bodyCls:string) => {
    srollFunction.doc = document.documentElement.scrollTop ? document.documentElement : bodyEle;
    srollFunction.scrollTop = srollFunction.doc.scrollTop;

    if (bodyEle.classList) {
      bodyEle.classList.add(bodyCls)
    } else {
      bodyEle.className += " " + bodyCls;
    }

    bodyEle.style.top = -srollFunction.scrollTop + 'px';
    srollFunction.bodyClassName = bodyEle.className;
  },
  beforeClose: (bodyEle:any, bodyCls:string) => {
    if (bodyEle.classList) {
      bodyEle.classList.remove(bodyCls)
    } else {
      srollFunction.reg = new RegExp("\\b" + bodyCls + "\\b", "gi");
      if (srollFunction.reg.test(srollFunction.bodyClassName)) {
        srollFunction.bodyClassName = srollFunction.bodyClassName.replace(srollFunction.reg, "");
        bodyEle.className = srollFunction.bodyClassName;
      }
    }

    bodyEle.style.top = "";
    srollFunction.doc.scrollTop = srollFunction.scrollTop;
  }
}
export { 
  isIos, 
  getCookies, 
  WeiXin, 
  isEquipment, 
  openApp, 
  downloadApp,
  navigatorToApp,
  openappfunc,
  regFenToYuan,
  regYuanToFen,
  formatDate,
  srollFunction
};
